export function getProductCardInsightsData(hit) {
  return {
    'data-insights-object-id': `${hit.product_id}-none`,
    'data-insights-position': hit.__position,
    'data-insights-query-id': hit.__queryID
  };
}
